import React, { createContext, useContext, useReducer } from 'react';
import Images from './constants/Images';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const initialState = {
    seoResponce: [],
    country: {
      code: 'in',
      name: 'India',
      flag: Images.indian_flag,
    },
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case 'GET_SEO_DATA':
        return { ...state, seoResponce: action.payload };
      case 'COUNTRY':
        return { ...state, country: action.payload };
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
